{
    "name": "rms",
    "prefix": "RMS",
    "version": "1.0.71",
    "description": "Rulmeca Monitoring System",
    "license": "https://themeforest.net/licenses/standard",
    "private": true,
    "scripts": {
        "8081": "ng serve --configuration start-8081 --port 4201",
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "refresh-persistent": "java -jar \\\\tqfileshare\\DiscoI\\lib\\jars\\typescriptPersistent.jar --ini configs-dev\\cadmo-inverso.ini --directory src\\app\\db\\ --prefixes RMS_A_,RMS_B_,RMS_C_,RMS_D_ --agave --strict",
        "refresh-persistent-linux": "java -jar /i/lib/jars/typescriptPersistentAgave.jar --ini configs-dev/cadmo-inverso.ini --directory src/app/db/ --prefixes ${npm_package_prefix}_A_,${npm_package_prefix}_B_,${npm_package_prefix}_C_,${npm_package_prefix}_D_ --agave",
        "refresh-persistent-tqdoc": "java -jar \\\\tqfileshare\\DiscoI\\lib\\jars\\typescriptPersistent.jar --ini configs-dev\\cadmo-inverso-tqdoc.ini --directory src\\app\\db\\tqdoc --prefixes TQDOC_A_ --proxy tqdoc --agave --strict",
        "refresh-persistent-imsign": "java -jar \\\\tqfileshare\\DiscoI\\lib\\jars\\typescriptPersistent.jar --ini configs-dev\\cadmo-inverso-imsign.ini --directory src\\app\\db\\imsign --prefixes UTE_A_ --proxy imsign --agave --strict",
        "refresh-persistent-dev": "java -jar E:\\Sviluppo\\eclipse-workspace\\cadmo2armonia\\dist\\typescriptPersistent.jar --ini configs-dev\\cadmo-inverso-demo.ini --directory src\\app\\db-demo\\ --prefixes TQDOC_A_ --agave --strict",
        "build4devel": "ng build --base-href /${npm_package_name}/ && @powershell cp configs/* dist/browser -r && @powershell jar cvf ${npm_package_name}.war -C dist/browser .",
        "build-war": "ng build --base-href /${npm_package_name}/ && cp configs/* dist/browser -r && jar cvf ${npm_package_name}.war -C dist/browser . && cp ${npm_package_name}.war /i/lib/wars",
        "build-war-windows-10": "@powershell if (Test-Path dist) { Remove-Item dist -Recurse -Force } && ng build --base-href /%npm_package_name%/ && @powershell cp configs/* dist/browser -r -Force && @powershell jar cvf %npm_package_name%.war -C dist/browser . && @powershell cp %npm_package_name%.war I:/lib/wars",
        "dist": "npm version patch && npm run build-war",
        "dist-minor": "npm version minor && npm run build-war",
        "dist-major": "npm version major && npm run build-war",
        "dist-win": "npm version patch && npm run build-war-windows-10",
        "dist-minor-win": "npm version minor && npm run build-war-windows-10",
        "dist-major-win": "npm version major && npm run build-war-windows-10"
    },
    "dependencies": {
        "@angular/animations": "20.3.6",
        "@angular/cdk": "20.2.9",
        "@angular/common": "20.3.6",
        "@angular/compiler": "20.3.6",
        "@angular/core": "20.3.6",
        "@angular/forms": "20.3.6",
        "@angular/material": "20.2.9",
        "@angular/material-luxon-adapter": "20.2.9",
        "@angular/platform-browser": "20.3.6",
        "@angular/platform-browser-dynamic": "20.3.6",
        "@angular/router": "20.3.6",
        "@asymmetrik/ngx-leaflet": "^17.0.0",
        "@danielmoncada/angular-datetime-picker": "^21.0.0",
        "@jsverse/transloco": "^7.5.1",
        "@jsverse/transloco-locale": "^7.0.1",
        "angular-plotly.js": "^20.0.0",
        "angularx-qrcode": "^19.0.0",
        "apexcharts": "4.3.0",
        "crypto-js": "4.2.0",
        "flatpickr": "^4.6.13",
        "highlight.js": "11.11.1",
        "leaflet": "^1.9.4",
        "leaflet.markercluster": "^1.5.3",
        "lodash-es": "4.17.21",
        "luxon": "^3.5.0",
        "ng-apexcharts": "1.15.0",
        "ngx-quill": "27.0.0",
        "perfect-scrollbar": "1.5.6",
        "plotly.js-dist-min": "^3.3.1",
        "quill": "2.0.3",
        "rxjs": "7.8.1",
        "tq-agave": "^5.1.10",
        "tslib": "2.8.1",
        "zone.js": "0.15.0"
    },
    "devDependencies": {
        "@angular/build": "^20.3.6",
        "@angular/cli": "20.3.6",
        "@angular/compiler-cli": "20.3.6",
        "@tailwindcss/typography": "0.5.15",
        "@types/chroma-js": "2.4.5",
        "@types/crypto-js": "4.2.2",
        "@types/highlight.js": "10.1.0",
        "@types/jasmine": "5.1.5",
        "@types/leaflet": "^1.9.21",
        "@types/leaflet.markercluster": "^1.5.6",
        "@types/lodash": "4.17.13",
        "@types/lodash-es": "4.17.12",
        "@types/luxon": "3.4.2",
        "@types/plotly.js-dist-min": "^2.3.4",
        "autoprefixer": "10.4.20",
        "chroma-js": "2.4.2",
        "jasmine-core": "5.1.2",
        "karma": "6.4.4",
        "karma-chrome-launcher": "3.2.0",
        "karma-coverage": "2.2.1",
        "karma-jasmine": "5.1.0",
        "karma-jasmine-html-reporter": "2.1.0",
        "lodash": "4.17.21",
        "postcss": "8.4.49",
        "prettier": "3.4.2",
        "prettier-plugin-organize-imports": "4.1.0",
        "prettier-plugin-tailwindcss": "0.6.9",
        "tailwindcss": "3.4.17",
        "typescript": "5.9.3"
    },
    "volta": {
        "node": "22.21.0"
    }
}
